import styled from "styled-components";
import { FlexColumnDiv } from "../../common.styles";
export const AddCommonInformedConsentParent = styled(FlexColumnDiv) `
    gap: 16px;
    width: 926px;
    padding: 40px 80px 40px 40px;
    ${({ centerAligned }) => centerAligned &&
    `
            margin: auto 0;
        `}
`;
